// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.template_endloc__gCEos {
  border: 1px solid red !important;
  border-radius: 5px;
}

.template_invalid_input_icon__beUNm {
  position: absolute;
  top: 6px;
  right: 35px;
  z-index: 10;
  color: black;
}

.template_clearbtn1__Q9WTB {
  position: absolute;
  top: 30px;
  right: 20px;
  z-index: 10;
}

.template_clearbtnSE__FXsMq {
  position: absolute;
  top: 29px;
  right: 27px;
  z-index: 10;
}

.template_clearbtn2__091AW {
  position: absolute;
  top: 30px;
  right: 35px;
  z-index: 10;
}

.template_clearbtn3__VegJp {
  position: absolute;
  top: 127px;
  right: 34px;
  z-index: 10;
}

.template_clearbtn__GbXUN {
  position: absolute;
  top: 8px;
  right: 48.5px;
  z-index: 110;
}

.template_clearbtnsearch__U8SMm {
  position: absolute;
  top: 7px;
  right: 10px;
  z-index: 10;
}

.template_clearbtnsearch1__WovI\\+ {
  position: absolute;
  top: 7px;
  right: 20px;
  z-index: 10;
}

.template_control1__NLEMR {
  z-index: 0 !important;
}

.template_modal-content__FyedE {
  display: none !important;
}

.template_Modal__76JiV {
  display: flex;
  height: 100vh;
  max-width: 1000px;
  width: 100%;
  align-items: center;
}

.template_Modal1__ytbqm {
  display: flex;
  max-width: 1000px;
  width: 100%;
}

.template_DragDrop__DVTr0 {
  border: 4px dashed #c7c7c7;
  width: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0px auto;
  height: 250px;
  overflow: hidden;
  border-radius: 10px;
}

.template_DragDrop1__ETphI {
  border: 3px dashed #c7c7c7;
  margin: 6px auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px;
  width: 100%;
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  aspect-ratio: 4/3;
}

.template_DragDropModal__pp8xb {
  border: 3px dashed #c7c7c7;
  margin: 6px auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 90%;
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  aspect-ratio: 4/3;
}

.template_DragText1__gB3ci {
  display: flex;
  align-items: center;
  text-align: center;
  position: absolute;
  font-weight: bolder;
}

.template_Preview__kblLj {
  width: 250px;
  height: 250px;
  position: absolute;
  object-fit: cover;
  border-radius: 10px;
}

.template_PreviewModal__zE9b- {
  width: 100%;
  position: absolute;
  object-fit: cover;
  border-radius: 10px;
  aspect-ratio: 4/3;
}

.template_AddPreview__lKRrf {
  width: 100%;
  height: 100%;
  position: absolute;
  object-fit: cover;
  border-radius: 10px;
}

.template_DropInput__FF1WO {
  opacity: 0;
}

.template_DropInput__FF1WO input {
  height: 200px;
  width: 100vw;
}

.template_DropInputModal__dXvAS {
  opacity: 0;
}

.template_DropInputModal__dXvAS input {
  height: 300px;
  width: 100%;
}

.template_DragText__vN3JV {
  display: flex;
  align-items: center;
  position: absolute;
  font-weight: 500;
  padding: 5px;
  text-align: center;
}

@media (max-width: 767px) {
  .template_Hidden__b6XU8 {
    display: none;
  }
}
::-webkit-scrollbar {
  width: 8px;
  background-color: whitesmoke;
  border-radius: 3px;
  height: 8px;
}

::-webkit-scrollbar-thumb:vertical {
  background-color: grey;
  border-radius: 6px;
  border: 2px solid white;
}

::-webkit-scrollbar-thumb:horizontal {
  background-color: grey;
  border-radius: 6px;
  border: 2px solid white;
}

.template_GeoGrandContainer__wyCtz {
  display: flex;
  justify-content: end;
}

.template_GeoItem__gByOz {
  padding: 10px;
  border-bottom: 1px solid gainsboro;
  margin: 0px;
  background-color: white;
  text-transform: capitalize;
}

.template_GeoItem__gByOz:hover {
  background-color: whitesmoke;
}

.template_gSection__RwIQn {
  background-color: #1c243b;
  margin: 5px;
  position: relative;
  border-radius: 5px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.template_gClosebtn__5g08c {
  position: relative;
  right: 20px;
  z-index: 2;
  margin: 3px;
}

.template_gClosebtn1__lj\\+33 {
  position: absolute;
  right: 80px;
}

.template_gClosebtn2__MB1GB {
  position: absolute;
  right: 67px;
}

.template_gClosebtnJust__71k8t {
  justify-content: end;
  padding: 5px 13px;
}

.template_gImg__eyuQg {
  padding: 2px;
}

.template_searchGallery__8We2m {
  background-color: #ffffff !important;
}

.template_GsearchBtn__K3Pqc {
  position: absolute;
  top: 0px;
  margin: 3px;
  right: 0px;
}

.template_ResultNotFound__h-Jme {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.template_ImgCon__8Hl5l {
  padding: 10px;
  overflow: auto;
  margin-top: 10px;
  height: 70vh;
}

.template_ImgGSpinner__pSKqz {
  display: flex;
  height: 65vh;
  justify-content: center;
  align-items: center;
}

.template_paginationBox__4\\+1Ti {
  display: flex;
  justify-content: space-around;
  padding: 10px;
  margin-top: 30px;
}

.template_LeftSec__YX725 {
  transition: 0.3s ease;
}

.template_GPCloseContainer__9DTgC {
  position: absolute;
  transition: 0.4s ease;
  right: -100vw;
  z-index: 2;
}

.template_GPOpenContainer__Tj4Pi {
  right: 0%;
  position: relative;
  transition: 0.4s ease;
  z-index: 2;
}`, "",{"version":3,"sources":["webpack://./src/styles/template.module.scss","webpack://./src/styles/globalScroll.module.scss","webpack://./src/styles/ItemsStyle/externalplace.module.scss","webpack://./src/styles/ItemsStyle/galleryplace.module.scss"],"names":[],"mappings":"AAAA;EACE,gCAAA;EACA,kBAAA;AACF;;AACA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;AAEF;;AAAA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;AAGF;;AADA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;AAIF;;AAFA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;AAKF;;AAHA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;AAMF;;AAJA;EACE,kBAAA;EACA,QAAA;EACA,aAAA;EACA,YAAA;AAOF;;AACA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;AAEF;;AAAA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;AAGF;;AADA;EAEE,qBAAA;AAGF;;AADA;EACE,wBAAA;AAIF;;AAFA;EACE,aAAA;EACA,aAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;AAKF;;AAHA;EACE,aAAA;EAEA,iBAAA;EACA,WAAA;AAKF;;AAHA;EACE,0BAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;AAMF;;AAJA;EACE,0BAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AAOF;;AALA;EACE,0BAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AAQF;;AANA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AASF;;AAPA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;AAUF;;AARA;EACE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;AAWF;;AATA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;AAYF;;AAVA;EACE,UAAA;AAaF;;AAXA;EACE,aAAA;EACA,YAAA;AAcF;;AAZA;EACE,UAAA;AAeF;;AAbA;EACE,aAAA;EACA,WAAA;AAgBF;;AAdA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AAiBF;;AANA;EACE;IACE,aAAA;EASF;AACF;AC1LA;EACI,UAAA;EACA,4BAAA;EACA,kBAAA;EACA,WAAA;AD4LJ;;AC1LA;EACI,sBAAA;EACA,kBAAA;EACA,uBAAA;AD6LJ;;AC3LA;EACI,sBAAA;EACA,kBAAA;EACA,uBAAA;AD8LJ;;AE3MA;EACI,aAAA;EACA,oBAAA;AF8MJ;;AEjMA;EACI,aAAA;EACA,kCAAA;EACA,WAAA;EACA,uBAAA;EACA,0BAAA;AFoMJ;;AElMA;EACI,4BAAA;AFqMJ;;AGvNA;EACE,yBAAA;EAEA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,2BAAA;EACA,4BAAA;AHyNF;;AGvNA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;AH0NF;;AGxNA;EACE,kBAAA;EACA,WAAA;AH2NF;;AGzNA;EACE,kBAAA;EACA,WAAA;AH4NF;;AG1NA;EACE,oBAAA;EACA,iBAAA;AH6NF;;AG3NA;EACE,YAAA;AH8NF;;AG5NA;EAGE,oCAAA;AH6NF;;AG3NA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;AH8NF;;AG5NA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AH+NF;;AG7NA;EACE,aAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;AHgOF;;AG9NA;EACE,aAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;AHiOF;;AG/NA;EACE,aAAA;EACA,6BAAA;EACA,aAAA;EACA,gBAAA;AHkOF;;AGhOA;EACI,qBAAA;AHmOJ;;AGjOA;EACI,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,UAAA;AHoOJ;;AGjOA;EACI,SAAA;EACA,kBAAA;EACA,qBAAA;EACA,UAAA;AHoOJ","sourcesContent":[".endloc {\n  border: 1px solid red !important;\n  border-radius: 5px;\n}\n.invalid_input_icon {\n  position: absolute;\n  top: 6px;\n  right: 35px;\n  z-index: 10;\n  color: black;\n}\n.clearbtn1 {\n  position: absolute;\n  top: 30px;\n  right: 20px;\n  z-index: 10;\n}\n.clearbtnSE {\n  position: absolute;\n  top: 29px;\n  right: 27px;\n  z-index: 10;\n}\n.clearbtn2 {\n  position: absolute;\n  top: 30px;\n  right: 35px;\n  z-index: 10;\n}\n.clearbtn3 {\n  position: absolute;\n  top: 127px;\n  right: 34px;\n  z-index: 10;\n}\n.clearbtn {\n  position: absolute;\n  top: 8px;\n  right: 48.5px;\n  z-index: 110;\n}\n// .clearbtntype{\n//   position: absolute;\n//   top: 30px;\n//   right: 50px;\n//   z-index: 10;\n// }\n.clearbtnsearch {\n  position: absolute;\n  top: 7px;\n  right: 10px;\n  z-index: 10;\n}\n.clearbtnsearch1 {\n  position: absolute;\n  top: 7px;\n  right: 20px;\n  z-index: 10;\n}\n.control1 {\n  // display: none !important;\n  z-index: 0 !important;\n}\n.modal-content {\n  display: none !important;\n}\n.Modal {\n  display: flex;\n  height: 100vh;\n  max-width: 1000px;\n  width: 100%;\n  align-items: center;\n}\n.Modal1 {\n  display: flex;\n  // height: 100vh;\n  max-width: 1000px;\n  width: 100%;\n}\n.DragDrop {\n  border: 4px dashed rgb(199, 199, 199);\n  width: 250px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0px auto;\n  height: 250px;\n  overflow: hidden;\n  border-radius: 10px;\n}\n.DragDrop1 {\n  border: 3px dashed rgb(199, 199, 199);\n  margin: 6px auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0px;\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n  border-radius: 10px;\n  aspect-ratio: 4/3;\n}\n.DragDropModal {\n  border: 3px dashed rgb(199, 199, 199);\n  margin: 6px auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 90%;\n  position: relative;\n  overflow: hidden;\n  border-radius: 10px;\n  aspect-ratio: 4/3;\n}\n.DragText1 {\n  display: flex;\n  align-items: center;\n  text-align: center;\n  position: absolute;\n  font-weight: bolder;\n}\n.Preview {\n  width: 250px;\n  height: 250px;\n  position: absolute;\n  object-fit: cover;\n  border-radius: 10px;\n}\n.PreviewModal {\n  width: 100%;\n  position: absolute;\n  object-fit: cover;\n  border-radius: 10px;\n  aspect-ratio: 4/3;\n}\n.AddPreview {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  object-fit: cover;\n  border-radius: 10px;\n}\n.DropInput {\n  opacity: 0;\n}\n.DropInput input {\n  height: 200px;\n  width: 100vw;\n}\n.DropInputModal {\n  opacity: 0;\n}\n.DropInputModal input {\n  height: 300px;\n  width: 100%;\n}\n.DragText {\n  display: flex;\n  align-items: center;\n  position: absolute;\n  font-weight: 500;\n  padding: 5px;\n  text-align: center;\n}\n\n// @media (max-width: 1024px) {\n//   .gOpen {\n//     width: 50%;\n//   }\n//   .gSection {\n//     width: 50%;\n//   }\n// }\n@media (max-width: 767px) {\n  .Hidden {\n    display: none;\n  }\n  // .gOpen {\n  //   width: 70%;\n  // }\n  // .gOpenUp{\n  //   width: 70%;\n  // }\n  // .gSection {\n  //   width: 70%;\n  // }\n}\n@import \"./globalScroll.module.scss\",\n  \"./ItemsStyle/externalplace.module.scss\";\n","::-webkit-scrollbar {\n    width: 8px;\n    background-color: whitesmoke;\n    border-radius: 3px;\n    height: 8px;\n}\n::-webkit-scrollbar-thumb:vertical {\n    background-color: grey;\n    border-radius: 6px;\n    border: 2px solid white;\n}\n::-webkit-scrollbar-thumb:horizontal {\n    background-color: grey;\n    border-radius: 6px;\n    border: 2px solid white;\n}\n","\n.GeoGrandContainer{\n    display: flex;\n    justify-content: end;\n}\n.GeoContainer {\n    // right: 0;\n    // background-color: white;\n    // max-height: 300px;\n    // overflow: auto;\n    // border: 1px solid gainsboro;\n    // border-radius: 5px;\n    // box-shadow: 0 0 3px #ccc;\n    // margin-bottom: 5px;\n}\n\n.GeoItem {\n    padding: 10px;\n    border-bottom: 1px solid gainsboro;\n    margin: 0px;\n    background-color: white;\n    text-transform: capitalize;\n}\n.GeoItem:hover{\n    background-color: whitesmoke;\n}\n\n@import '../ItemsStyle//galleryplace.module.scss'",".gClose {\n \n}\n.gOpen {\n \n}\n.gSection {\n  background-color: #1c243b;\n  // min-height: 100vh;\n  margin: 5px;\n  position: relative;\n  border-radius: 5px;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n}\n.gClosebtn {\n  position: relative;\n  right: 20px;\n  z-index: 2;\n  margin: 3px;\n}\n.gClosebtn1 {\n  position: absolute;\n  right: 80px;\n}\n.gClosebtn2 {\n  position: absolute;\n  right: 67px;\n}\n.gClosebtnJust {\n  justify-content: end;\n  padding: 5px 13px;\n}\n.gImg {\n  padding: 2px;\n}\n.searchGallery {\n  // top: 0px;\n  // position: absolute;\n  background-color: #ffffff !important;\n}\n.GsearchBtn {\n  position: absolute;\n  top: 0px;\n  margin: 3px;\n  right: 0px;\n}\n.ResultNotFound{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n}\n.ImgCon {\n  padding: 10px;\n  overflow: auto;\n  margin-top: 10px;\n  height: 70vh;\n}\n.ImgGSpinner{\n  display: flex;\n  height: 65vh;\n  justify-content: center;\n  align-items: center;\n}\n.paginationBox{\n  display: flex;\n  justify-content: space-around;\n  padding: 10px;\n  margin-top: 30px;\n}\n.LeftSec{\n    transition: 0.3s ease;\n}\n.GPCloseContainer{\n    position: absolute;\n    transition: 0.4s ease;\n    right: -100vw;\n    z-index: 2;\n}\n\n.GPOpenContainer{\n    right: 0%;\n    position: relative;\n    transition: 0.4s ease;\n    z-index: 2;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"endloc": `template_endloc__gCEos`,
	"invalid_input_icon": `template_invalid_input_icon__beUNm`,
	"clearbtn1": `template_clearbtn1__Q9WTB`,
	"clearbtnSE": `template_clearbtnSE__FXsMq`,
	"clearbtn2": `template_clearbtn2__091AW`,
	"clearbtn3": `template_clearbtn3__VegJp`,
	"clearbtn": `template_clearbtn__GbXUN`,
	"clearbtnsearch": `template_clearbtnsearch__U8SMm`,
	"clearbtnsearch1": `template_clearbtnsearch1__WovI+`,
	"control1": `template_control1__NLEMR`,
	"modal-content": `template_modal-content__FyedE`,
	"Modal": `template_Modal__76JiV`,
	"Modal1": `template_Modal1__ytbqm`,
	"DragDrop": `template_DragDrop__DVTr0`,
	"DragDrop1": `template_DragDrop1__ETphI`,
	"DragDropModal": `template_DragDropModal__pp8xb`,
	"DragText1": `template_DragText1__gB3ci`,
	"Preview": `template_Preview__kblLj`,
	"PreviewModal": `template_PreviewModal__zE9b-`,
	"AddPreview": `template_AddPreview__lKRrf`,
	"DropInput": `template_DropInput__FF1WO`,
	"DropInputModal": `template_DropInputModal__dXvAS`,
	"DragText": `template_DragText__vN3JV`,
	"Hidden": `template_Hidden__b6XU8`,
	"GeoGrandContainer": `template_GeoGrandContainer__wyCtz`,
	"GeoItem": `template_GeoItem__gByOz`,
	"gSection": `template_gSection__RwIQn`,
	"gClosebtn": `template_gClosebtn__5g08c`,
	"gClosebtn1": `template_gClosebtn1__lj+33`,
	"gClosebtn2": `template_gClosebtn2__MB1GB`,
	"gClosebtnJust": `template_gClosebtnJust__71k8t`,
	"gImg": `template_gImg__eyuQg`,
	"searchGallery": `template_searchGallery__8We2m`,
	"GsearchBtn": `template_GsearchBtn__K3Pqc`,
	"ResultNotFound": `template_ResultNotFound__h-Jme`,
	"ImgCon": `template_ImgCon__8Hl5l`,
	"ImgGSpinner": `template_ImgGSpinner__pSKqz`,
	"paginationBox": `template_paginationBox__4+1Ti`,
	"LeftSec": `template_LeftSec__YX725`,
	"GPCloseContainer": `template_GPCloseContainer__9DTgC`,
	"GPOpenContainer": `template_GPOpenContainer__Tj4Pi`
};
export default ___CSS_LOADER_EXPORT___;
